import axios from 'axios';
import { getUserSession } from '../utils/session';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE ? process.env.REACT_APP_API_BASE + '/api' : 'https://localhost:44381/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach Authorization for current role
axiosInstance.interceptors.request.use((config) => {
  // Determine UI context (not API URL!) using current path
  // const pathname = window.location.pathname;

  // let role: 'customer' | 'owner' | 'manager' | 'dining associate' | undefined;
  // if (pathname.startsWith('/customer')) role = 'customer';

  // Get session for the current role
  const session = getUserSession();
    //console.log('getUserSession1 :', session);
    if (session && session.token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${session.token}`;
    }

  return config;
});

// Handle Unauthorized redirect per role
axiosInstance.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401) {
      let role: 'customer' | 'owner' | 'manager' | 'dining associate' | undefined;
      const url = error.config?.url || '';
      if (url.startsWith('/customer')) role = 'customer';


      //console.log('clearing localstorage from axiosinstace');
      localStorage.clear();
      if (role === 'customer') window.location.href = '/customer-login';
      else window.location.href = '/restaurant/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
